import gsap from 'gsap';
import { ScrambleTextPlugin } from './util/ScrambleTextPlugin.min.js';

gsap.registerPlugin(ScrambleTextPlugin);

const init = (isRM) => {
  if (isRM) return;
  const buttons = document.querySelectorAll('.button');

  buttons.forEach((button) => {
    button.dataset.text = button.innerHTML;
    let isAnimating = false;

    button.addEventListener('mouseenter', () => {
      if (!isAnimating) {
        isAnimating = true;
        gsap.set(button, {
          paddingLeft: 0,
          paddingRight: 0,
          width: gsap.getProperty(button, 'width')
        });

        gsap.to(button, {
          scrambleText: {
            chars: '10',
            text: button.dataset.text,
            revealDelay: 0.2
          },
          duration: 0.3,
          ease: 'none',
          onComplete: () => {
            gsap.set(button, { clearProps: 'all' });
            isAnimating = false;
          }
        });
      }
    });
  });
};

export { init };
